import { Fragment, useEffect } from 'react';

import Gap from 'bloko/blocks/gap';

import useTrls from 'hooks/translation/useTrls';

import GiftForm from 'components/Admin/GiftFormModal';
import fetchInvoicesByUrl from 'components/Admin/Invoices/fetchInvoicesByUrl';
import Filter from 'components/Admin/Invoices/Filter';
import InvoicesTable from 'components/Admin/Invoices/InvoicesTable';
import TitlePage from 'components/Admin/TitlePage';

import { useDispatch } from 'store/utils';

const Invoices = () => {
    const dispatch = useDispatch();
    const trl = useTrls();

    useEffect(() => {
        dispatch(fetchInvoicesByUrl());
    }, [dispatch]);
    return (
        <Fragment>
            <TitlePage>{trl('admin.Invoices.title')}</TitlePage>
            <Gap top bottom>
                <Filter />
                <Gap top>
                    <InvoicesTable />
                </Gap>
            </Gap>
            <GiftForm />
        </Fragment>
    );
};

export default Invoices;
